interface Props {
    width?: number;
    height?: number;
    hexColor?: string;
}

export const Minus = ({ width = 12, height = 4, hexColor = "#000000", }: Props) => {
    return (
        <svg width={width} height={height} viewBox="0 0 16 2" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 1H16" stroke={hexColor} strokeWidth="1.5"/>
        </svg>
    );
};

export default Minus;
